import {RegionType} from "@pg-rp/common-types";

import type {ISearchInputRegion} from "../../../../search/components/ISearchInputValue";

const REGION_TYPES: ReadonlySet<unknown> = new Set(Object.values(RegionType).filter((value) => typeof value === "number"));

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !Array.isArray(value);

const isNonEmptyString = (value: unknown): value is string => typeof value === "string" && value.trim().length > 0;

const isRegionId = (value: unknown): value is number => typeof value === "number" && Number.isInteger(value) && value > 0;

const isValidParent = (value: unknown): boolean =>
    value === null || (isRecord(value) && isRegionId(value.id) && isNonEmptyString(value.name) && isNonEmptyString(value.slug));

/**
 * Guards what goes into (and comes out of) the main search store. `RecentFiltersSearch` and the personalized homepage
 * read these fields without a try/catch, so a region that fails here is never saved. `is_leaf_node` is optional because
 * the REGION_DETAIL scenario (`fetchSingleRegionSimple`) does not return it.
 */
export const isValidSearchInputRegion = (value: unknown): value is ISearchInputRegion =>
    isRecord(value) &&
    isRegionId(value.id) &&
    REGION_TYPES.has(value.type) &&
    isNonEmptyString(value.name) &&
    isNonEmptyString(value.slug) &&
    isNonEmptyString(value.full_name) &&
    isNonEmptyString(value.full_name_reverted) &&
    typeof value.short_name === "string" &&
    typeof value.name_declension_what === "string" &&
    typeof value.name_declension_where === "string" &&
    isValidParent(value.parent) &&
    (value.is_leaf_node === undefined || typeof value.is_leaf_node === "boolean");
import {RegionType} from "@pg-rp/common-types";

import type {ISearchInputRegion} from "../../../../search/components/ISearchInputValue";

const REGION_TYPES: ReadonlySet<unknown> = new Set(Object.values(RegionType).filter((value) => typeof value === "number"));

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !Array.isArray(value);

const isNonEmptyString = (value: unknown): value is string => typeof value === "string" && value.trim().length > 0;

const isRegionId = (value: unknown): value is number => typeof value === "number" && Number.isInteger(value) && value > 0;

const isValidParent = (value: unknown): boolean =>
    value === null || (isRecord(value) && isRegionId(value.id) && isNonEmptyString(value.name) && isNonEmptyString(value.slug));

/**
 * Guards what goes into (and comes out of) the main search store. `RecentFiltersSearch` and the personalized homepage
 * read these fields without a try/catch, so a region that fails here is never saved. `is_leaf_node` is optional because
 * the REGION_DETAIL scenario (`fetchSingleRegionSimple`) does not return it.
 */
export const isValidSearchInputRegion = (value: unknown): value is ISearchInputRegion =>
    isRecord(value) &&
    isRegionId(value.id) &&
    REGION_TYPES.has(value.type) &&
    isNonEmptyString(value.name) &&
    isNonEmptyString(value.slug) &&
    isNonEmptyString(value.full_name) &&
    isNonEmptyString(value.full_name_reverted) &&
    typeof value.short_name === "string" &&
    typeof value.name_declension_what === "string" &&
    typeof value.name_declension_where === "string" &&
    isValidParent(value.parent) &&
    (value.is_leaf_node === undefined || typeof value.is_leaf_node === "boolean");
